/* ACTION TYPES */
export enum BRAND_KIT_ACTIONS {
    SET_BRAND_KITS_LOADING = 'SET_BRAND_KITS_LOADING',
    STORE_BRAND_KITS = 'STORE_BRAND_KITS',
    SET_SELECTED_BRAND_KIT_ID = 'SET_SELECTED_BRAND_KIT_ID',
}

export type BrandKitFontId = number | null; // just id, null when slot is empty
export type BrandKitWatermarkId = string | null; // UUID string, null when slot is empty
